export const iconFontAwesomeMapsMagnifyingGlassMinus = (
	<i className="fa-solid fa-magnifying-glass-minus"></i>
);
